export default __webpack_public_path__ + "static/media/ticket-icon-blue.d9e0c9e1.svg";